import {
  AnualCalendarCaptionDayDto,
  AnualCalendarDayDto,
  AnualCalendarDayTypeDto,
  AnualCalendarMonthDto,
  AnualCalendarTotalsDto,
  AnualCalendarWeekDto,
  LababsVacationsDataDto,
  LababsVacationsDto,
  VacationsYearDto,
  VacationsYearsDto
} from '@app/data/dtos/lababs/lababs-vacations.dto';
import {
  AnualCalendarCaptionDay,
  AnualCalendarDay,
  AnualCalendarDayType,
  AnualCalendarMonth,
  AnualCalendarTotals,
  AnualCalendarWeek,
  LababsVacations,
  VacationsYear
} from '@app/entities/models/lababs/lababs-vacations.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapLababsVacations: MapFromFn<LababsVacationsDto, LababsVacations> = (value) =>
  Builder.forModel(LababsVacations)
    .months(value.months.map((month) => mapAnualCalendarMonth(month)))
    .captions(value.captions.map((caption) => mapAnualCalendarCaptionDay(caption)))
    .totals(value.totals.map((total) => mapAnualCalendarTotals(total)))
    .year(String(value.year))
    .build();

export const mapLababsVacationsData: MapFromFn<LababsVacationsDataDto, LababsVacations[]> = (value) =>
  value.vacations.map(mapLababsVacations);

export const mapAnualCalendarDay: MapFromFn<AnualCalendarDayDto, AnualCalendarDay> = (value) =>
  Builder.forModel(AnualCalendarDay)
    .date(value.date)
    .dayLabel(value.day_label)
    .dayType(mapAnualCalendarDayType(value.day_type))
    .build();

export const mapAnualCalendarDayType: MapFromFn<AnualCalendarDayTypeDto | null, AnualCalendarDayType | null> = (
  value
) => {
  if (!value) {
    return null;
  }

  return Builder.forModel(AnualCalendarDayType)
    .ids(value.ids)
    .name(value.name)
    .primaryColour(value.primary_colour)
    .secondaryColour(value.secondary_colour)
    .primaryShape(value.primary_shape)
    .secondaryShape(value.secondary_shape)
    .isWorkingDay(value.is_working_day)
    .build();
};

export const mapAnualCalendarWeek: MapFromFn<AnualCalendarWeekDto, AnualCalendarWeek> = (value) =>
  Builder.forModel(AnualCalendarWeek)
    .days(value.days.map((day) => mapAnualCalendarDay(day)))
    .build();

export const mapAnualCalendarMonth: MapFromFn<AnualCalendarMonthDto, AnualCalendarMonth> = (value) =>
  Builder.forModel(AnualCalendarMonth)
    .monthLabel(value.name)
    .yearLabel(String(value.year))
    .weeks(value.weeks.map((week) => mapAnualCalendarWeek(week)))
    .build();

export const mapAnualCalendarCaptionDay: MapFromFn<AnualCalendarCaptionDayDto, AnualCalendarCaptionDay> = (value) =>
  Builder.forModel(AnualCalendarCaptionDay)
    .id(value.id)
    .name(value.name)
    .colour(value.colour)
    .order(value.order)
    .shape(value.shape)
    .build();

export const mapAnualCalendarTotals: MapFromFn<AnualCalendarTotalsDto, AnualCalendarTotals> = (value) =>
  Builder.forModel(AnualCalendarTotals).dayType(value.day_type).total(value.total).build();

export const mapVacationsYearsData: MapFromFn<VacationsYearsDto, VacationsYear[]> = (value) =>
  value.calendar.map(mapVacationsYear);

export const mapVacationsYear: MapFromFn<VacationsYearDto, VacationsYear> = (value) =>
  Builder.forModel(VacationsYear).year(value.year).build();
